<template>
  <div class="board-page">
    <div class="gs-page-hero">
      <div class="gs-hero-art" :class="heroClass" aria-hidden="true"></div>
      <div class="gs-page-hero-inner">
        <div>
          <h1>{{ title }}</h1>
          <p>{{ desc }}</p>
        </div>
      </div>
      <div class="gs-page-hero-metrics" aria-hidden="true">
        <div class="gs-page-hero-metric">
          <div class="metric-num"><em>&nbsp;</em></div>
          <div class="metric-label">&nbsp;</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleBoard',
  computed: {
    title() {
      return (this.$route.meta && this.$route.meta.title) || ''
    },
    desc() {
      return (this.$route.meta && this.$route.meta.desc) || '1.0 先保留入口，完整内容后续上线。'
    },
    heroClass() {
      const path = String((this.$route && this.$route.path) || '')
      if (path.indexOf('/lab') === 0) return 'is-lab'
      return 'is-college'
    }
  }
}
</script>

<style scoped>
.board-page {
  width: 100%;
  padding-bottom: 48px;
}
</style>
